import { UserRole } from '../../enum/UserRole';

export const rolesForAdminManagement = [
  UserRole.SUPER_USER,
];
